import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loyalty_signup_method.js";
//#region src/loyalty_signup_method_helper.ts
var loyalty_signup_method_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(loyaltySignupMethod) {
	switch (loyaltySignupMethod) {
		case "sms": return "SMS";
		case "qr_code": return "QR Code";
	}
}
//#endregion
export { loyalty_signup_method_helper_exports, name };

//# sourceMappingURL=loyalty_signup_method_helper.js.map